import { useTrans } from "@/translations";

import { useContext } from "react";

import { twMerge } from "tailwind-merge";

import { RecyclingRateTrendContext } from "../../../context";
import type { ChartType } from "../../../types";
import { OPTIONS_CHART_BUTTONS } from "../constants";

export const ChartTypeSelector: React.FC = () => {
  const { t } = useTrans();
  const { chartType: selectedChartType, setChartType } = useContext(
    RecyclingRateTrendContext,
  );

  return (
    <div className="p-3">
      <div className="text-grey6 mb-[9px] text-[10.5px] font-bold tracking-[0.05] uppercase">
        {t("homePage:optionsChartType")}
      </div>

      <div className="bg-grey1 border-grey2 inline-flex gap-[3px] rounded-lg border p-[3px]">
        {OPTIONS_CHART_BUTTONS.map((btn) => (
          <button
            key={btn.id}
            onClick={() => setChartType(btn.id as ChartType)}
            className={twMerge(
              "flex cursor-pointer items-center gap-[4.95px] rounded-md px-[9.9px] py-[3.3px] text-[11.5px] font-medium transition-colors",
              selectedChartType === btn.id
                ? "bg-black font-semibold text-white"
                : "text-grey6",
            )}
          >
            {btn.icon}
            {t(btn.label)}
          </button>
        ))}
      </div>
    </div>
  );
};
